import React from 'react';
import { SideNav } from '../../components/SideNav';
import { PageWrapper, Page, PageContent } from './PageTemplates';

type PropsType = {
  blurred?: boolean;
};

const DeveloperPage: React.FC<PropsType> = ({ blurred, children }) => (
  <PageWrapper className={`${blurred ? 'blurred' : ''}`}>
    <Page>
      <SideNav userRole="Developer" />

      <PageContent>{children}</PageContent>
    </Page>
  </PageWrapper>
);

export default DeveloperPage;
